export default __webpack_public_path__ + "static/media/daynight_white.98d715e5.png";